import React, { useEffect, useState } from "react";

import Loading from "./Loading";

const LEVEL_COLORS = {
  A1: "#5cb85c",
  A2: "#337ab7",
  B1: "#f0ad4e",
  B2: "#d9534f"
};

function LevelBadge({ level }) {
  return (
    <span
      style={{
        background: LEVEL_COLORS[level] || "#777",
        borderRadius: 4,
        color: "#fff",
        display: "inline-block",
        fontSize: 11,
        fontWeight: "bold",
        marginRight: 6,
        padding: "2px 6px"
      }}
    >
      {level}
    </span>
  );
}

function CompInputCard({ compInput }) {
  const { cefrLevel, category, contentType, title, url } = compInput;
  return (
    <a href={url} className="comp-input-card-link" style={{ textDecoration: "none" }}>
      <div className="comp-input-card">
        <div className="comp-input-card-body">
          <LevelBadge level={cefrLevel} />
          {category && <span className="comp-input-category-tag">{category}</span>}
          <h4 className="comp-input-card-title" style={{ marginTop: 8 }}>{title}</h4>
          <p className="comp-input-card-type" style={{ color: "#999", fontSize: 12, margin: 0 }}>{contentType.replace("_", " ")}</p>
        </div>
      </div>
    </a>
  );
}

export default function CompInputs({ url }) {
  const [compInputs, setCompInputs] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [levelFilter, setLevelFilter] = useState(null);

  useEffect(() => {
    $.ajax({ url })
      .done((data) => {
        setCompInputs(data.compInputs);
        setLoaded(true);
      })
      .fail(() => {
        alert("Failed to load comprehensible input texts!");
      });
  }, []);

  if (!loaded) {
    return <Loading />;
  }

  if (!compInputs.length) {
    return <p>No comprehensible input texts available yet.</p>;
  }

  const levels = [...new Set(compInputs.map((ci) => ci.cefrLevel))].sort();
  const filtered = levelFilter ? compInputs.filter((ci) => ci.cefrLevel === levelFilter) : compInputs;

  return (
    <div>
      <h2 className="joystix" style={{ fontSize: 18, marginBottom: 16 }}>Comprehensible Input</h2>

      <div style={{ marginBottom: 16 }}>
        <button
          className={`btn btn-sm ${!levelFilter ? "btn-primary" : "btn-default"}`}
          onClick={() => setLevelFilter(null)}
          style={{ marginRight: 4 }}
        >
          All
        </button>
        {levels.map((level) => (
          <button
            key={level}
            className={`btn btn-sm ${levelFilter === level ? "btn-primary" : "btn-default"}`}
            onClick={() => setLevelFilter(level)}
            style={{ marginRight: 4 }}
          >
            {level}
          </button>
        ))}
      </div>

      <div className="row">
        {filtered.map((ci) => (
          <div key={ci.id} className="col-xs-12 col-sm-6 col-md-4" style={{ marginBottom: 16 }}>
            <CompInputCard compInput={ci} />
          </div>
        ))}
      </div>
    </div>
  );
}
